import { render, staticRenderFns } from "./CustomerDeliveryAddressAttachment.vue?vue&type=template&id=3f49a830&scoped=true"
import script from "./CustomerDeliveryAddressAttachment.vue?vue&type=script&lang=js"
export * from "./CustomerDeliveryAddressAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f49a830",
  null
  
)

export default component.exports